(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["capilla-calculadora-page-content"] && !Shopify.designMode) return;
  try {
    (function () {
  var root = document.querySelector('[data-cktcalc]');
  if (!root) return;

  var cop0 = new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  var cop2 = new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 2, maximumFractionDigits: 2 });

  function money(n) { return isFinite(n) ? cop0.format(Math.round(n)) : '-'; }
  function money2(n) { return isFinite(n) ? cop2.format(n) : '-'; }
  function pct(n) { return isFinite(n) ? (n * 100).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%' : '-'; }
  function dec(n, d) { return isFinite(n) ? n.toLocaleString('es-CO', { minimumFractionDigits: d, maximumFractionDigits: d }) : '-'; }
  function val(id) { var el = root.querySelector('#ckt-' + id); var v = el ? parseFloat(el.value) : 0; return isNaN(v) ? 0 : v; }

  function compute() {
    var cps = val('cps'), verde = val('verde'), valorKg = val('valorKg'), factor = val('factor') || 1;
    var trL = val('trL'), trH = val('trH'), trN = val('trN'), sel = val('sel');
    var tueste = val('tueste'), empMoler = val('empMoler'), costoBolsa = val('costoBolsa'), costoSticker = val('costoSticker');
    var pesoTostado = val('pesoTostado'), gramaje = val('gramaje') || 1, transporte = val('transporte');
    var ventaCafe = val('ventaCafe'), iva = val('ivaPct') / 100;

    // INFORMACION COSTO CAFE
    var valorCarga = (cps === 0) ? (valorKg * 93.1) : (valorKg * 125);            // F15
    var valorCargaBase = (factor / 94) * valorCarga;                              // H15
    var pKgL = (valorCarga / 93.1) + trL + sel;                                   // F16
    var pKgH = (valorCarga / 93.1) + trH + sel;                                   // F17
    var pKgN = (valorCarga / 93.1) + trN + sel;                                   // F18
    var pGrL = pKgL / 1000, pGrH = pKgH / 1000, pGrN = pKgN / 1000;               // H16/H17/H18
    var cpsFactor = 1 - (70 / factor);                                            // F21
    var verdeKg = (cps + verde) * 70 / factor;                                    // F22
    var pctTueste = (verdeKg !== 0) ? 1 - (pesoTostado / verdeKg) : 0;            // F23
    var oneMinus = (1 - pctTueste) || 1;
    var pGrTostL = pGrL / oneMinus, pGrTostH = pGrH / oneMinus, pGrTostN = pGrN / oneMinus; // H21/H22/H23

    // COSTO PRODUCTO FINAL
    var cafeEnBolsa = gramaje;                                                    // F25 = C33
    var costoBolsaTotal = costoSticker + costoBolsa + empMoler;                   // H26
    var tuestePorBolsa = (tueste / 1000) * gramaje;                               // H28
    var fL = pGrTostL * cafeEnBolsa, fH = pGrTostH * cafeEnBolsa, fN = pGrTostN * cafeEnBolsa; // F26/F27/F28
    var costoFinL = fL + costoBolsaTotal + tuestePorBolsa;                        // E31
    var costoFinH = fH + costoBolsaTotal + tuestePorBolsa;                        // F31
    var costoFinN = fN + costoBolsaTotal + tuestePorBolsa;                        // G31

    // PAGO / PRECIO / UNIDADES
    var kTueste = verdeKg * tueste;                                               // K15
    var kTrL = cps * trL, kTrH = cps * trH, kTrN = cps * trN;                     // K16/K17/K18
    var lEmpaque = pesoTostado * 1000 / gramaje;                                  // L19
    var kEmpaque = lEmpaque * empMoler;                                           // K19
    var pagoTotL = kTueste + kTrL + kEmpaque;                                     // J22
    var pagoTotH = kTueste + kTrH + kEmpaque;                                     // K22
    var pagoTotN = kTueste + kTrN + kEmpaque;                                     // L22
    var pagoMatPrima = valorCarga;                                                // J24
    var pagosExtraTransp = ((cps + verde) !== 0) ? (transporte / (cps + verde) * gramaje) : 0; // J26
    var ivaPorBolsa = ventaCafe - (ventaCafe / (iva + 1));                        // J28

    // REPORTE DE VENTAS
    var totalUnidades = Math.floor(lEmpaque);                                     // G38
    var totalVenta = totalUnidades * ventaCafe;                                   // G37

    // BOTTOM TABLE
    var costoTblL = costoFinL + ivaPorBolsa;                                      // F41
    var costoTblH = costoFinH + ivaPorBolsa;                                      // G41
    var costoTblN = costoFinN + ivaPorBolsa;                                      // H41
    var utilL = ventaCafe - costoTblL;                                            // F43
    var utilH = ventaCafe - costoTblH;                                            // G43
    var utilN = ventaCafe - costoTblN;                                            // H43

    var out = {
      valorCarga: money(valorCarga), valorCargaBase: money(valorCargaBase),
      pKgL: money(pKgL), pKgH: money(pKgH), pKgN: money(pKgN),
      cpsFactor: pct(cpsFactor), verdeKg: dec(verdeKg, 2) + ' kg', pctTueste: pct(pctTueste),
      pGrTostL: money2(pGrTostL), pGrTostH: money2(pGrTostH), pGrTostN: money2(pGrTostN),
      cafeEnBolsa: dec(cafeEnBolsa, 0) + ' g', costoBolsaTotal: money(costoBolsaTotal), tuestePorBolsa: money(tuestePorBolsa),
      costoFinL: money(costoFinL), costoFinH: money(costoFinH), costoFinN: money(costoFinN),
      kTueste: money(kTueste), kTrL: money(kTrL), kTrH: money(kTrH), kTrN: money(kTrN), kEmpaque: money(kEmpaque),
      pagoTotL: money(pagoTotL), pagoTotH: money(pagoTotH), pagoTotN: money(pagoTotN),
      pagoMatPrima: money(pagoMatPrima), pagosExtraTransp: money(pagosExtraTransp), ivaPorBolsa: money(ivaPorBolsa),
      totalUnidades: dec(totalUnidades, 0), totalVenta: money(totalVenta),
      costoTblL: money(costoTblL), costoTblH: money(costoTblH), costoTblN: money(costoTblN),
      ventaTblL: money(ventaCafe), ventaTblH: money(ventaCafe), ventaTblN: money(ventaCafe),
      utilL: money(utilL), utilH: money(utilH), utilN: money(utilN),
      totalUtilL: money(utilL * totalUnidades), totalUtilH: money(utilH * totalUnidades), totalUtilN: money(utilN * totalUnidades)
    };

    for (var key in out) {
      if (!out.hasOwnProperty(key)) continue;
      var el = root.querySelector('[data-ckt-out="' + key + '"]');
      if (el) el.textContent = out[key];
    }
  }

  root.querySelectorAll('[data-ckt]').forEach(function (input) { input.addEventListener('input', compute); });
  compute();
})();
  } catch(e) { console.error(e); }
})();

})();
